<template>
  <div class="bodycontent">
    <div class="page_title">
      如意设置
    </div>
    <div style="margin-top: 15px">
      <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
    </div>
    <div class="table_box">
      <el-table :data="listData" border>
        <el-table-column label="Id" prop="id"></el-table-column>
        <el-table-column label="如意设备SN终端号" prop="device_sn"></el-table-column>
        <el-table-column label="绑定时间" prop="create_time"></el-table-column>
        <el-table-column label="门店" prop="show_store">
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button type="text" @click="Del(scope.row)" >解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="showForm" width="600px" :title="formTitle" @close="closeForm" :close-on-click-modal="false" :show-close="false">
      <div class="page_form">
        <el-form :model="formData" ref="formData" size="small" label-width="120px">
          <el-form-item label="支付宝店铺ID">
            <el-input v-model="formData.shop_id" style="width:310px" placeholder="支付宝店铺ID"></el-input>
          </el-form-item>
          <el-form-item label="设备SN终端号">
            <el-input class="input_box" v-model="formData.device_sn" placeholder="设备SN终端号"></el-input>
          </el-form-item>
          <el-form-item label="门店">
            <el-select v-model="formData.room_id">
              <el-option v-for="item in storeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="bottom_btn">
          <el-button size="medium" @click="closeForm">取消</el-button>
          <el-button size="medium" type="primary" @click="save">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {  ruyiList,ruyiDel,ruyiAdd } from "@/api/set";
import { storeSelect } from "@/api/employee";
import { mapGetters } from "vuex";
// import Template from "@/views/apply/newVip/set/smsConfig/template";
export default {
  // components: {Template},
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      listData: [], // 数据列表
      // page: 1,
      // total: 0,
      storeList: [], // 门店选项
      showForm: false,
      formTitle: "新增如意设备",
      // is_add: true, // 保存/修改
      formData: {
        device_sn: "",
        shop_id:'',
        room_id: ""
      },
      // dialogLoading: false
    }
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      storeSelect({app_id: this.app_id}).then(res => {
        if(res.code == 200){
          this.storeList = res.data;
          this.getData();
        }else{
          this.$message(res.msg)
        }
      })
    },
    getData(){
      var data = {
        app_id: this.app_id,
      }
      ruyiList(data).then(res => {
        if(res.code == 200){
          this.listData = res.data;
          this.l
          this.total = res.total
          this.listData.forEach(item => {
            // item.show_open = item.is_open == 1? "是":"否";
            item.show_store = item.room_id? this.storeList.find(x => x.id == item.room_id).name:"";
          })
        }else{
          this.$message(res.msg);
        }
      })
    },
    Del(row) {
      this.$confirm('此操作将解绑设备, 是否继续?','解绑',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type:'warning'
      }).then(()=>{
        ruyiDel({app_id: this.app_id, device_sn:row.device_sn,merchant_id:row.shop_id}).then(res=>{
          if(res.code == 200) {
            console.log(res)
            this.$message({
              type:'success',
              message:res.msg
            });
            this.getData()
          }else {
            this.$message({
              type:'error',
              message:res.msg
            });
          }
        })
      }).catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消解绑操作'
        });
      })

    },
    closeForm(){
      this.showForm = false
    },
    addItem(){
      this.showForm = true
    },
    save() {
      let data = {
        app_id:this.app_id,
        device_sn:this.formData.device_sn,
        room_id:this.formData.room_id,
        shop_id:this.formData.shop_id,
      }
      ruyiAdd(data).then(res=>{
        if(res.code == 200) {
          this.showForm = false
          this.$refs['formData'].resetFields();
          this.$message({
            type:'success',
            message:res.msg
          })
          this.getData()
          console.log(res)
        }else {
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bodycontent{
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding:0 18px;
  .page_title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .table_box{
    margin: 10px 0;
  }
}
.page_form{
  .input_box{
    width: 150px;
    margin-right: 10px;
  }
  .input_box_small{
    width: 50px;
  }
  .form_info_text{
    color: #aaa;
  }
  .bottom_btn{
    margin-top: 40px;
    text-align: center;
  }
}
</style>